exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-group-tab-header-container {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  user-select: none;\n}\n.input-group-tab-header-container .input-group-label.disabled {\n  opacity: 0.3;\n}\n.input-group-tab-header-container .default-group-label {\n  margin-top: 2px;\n  font-size: 12px;\n  font-weight: bold;\n  color: #9ba0aa;\n}\n", ""]);

// exports
